import { useEffect, useState } from 'react';
import Joyride, { Callback } from 'react-joyride';

import { useApplicationSetup } from '@page/application-setup/application-setup.hook';
import { userActions } from '@store/user/user.slice';

import { useMutation } from '@hook/common/use-mutation.hook';
import { useUserGuide } from '@hook/user/use-user-guide.hook';
import { useSaveGuidesMutation } from '@hook/user/user.hooks';

import { locale, steps } from './consumer-guide.options';
import { consumerGuideStyle } from './consumer-guide.style';

export const ConsumerGuide = () => {
  const { name } = useApplicationSetup();
  const { completedConsumer } = useUserGuide();
  const [run, setRun] = useState(false);
  const { action: saveGuides } = useMutation(useSaveGuidesMutation(), userActions, userActions.setGuides);

  const handleSaveGuides: Callback = ({ status }) => {
    if (status === 'skipped') {
      saveGuides({ completedCreateApplication: true, completedConsumer: true, completedDashboard: true });
    }
    if (status === 'finished') {
      saveGuides({ completedConsumer: true });
    }
  };

  useEffect(() => void setRun(!completedConsumer), [name, run, completedConsumer]);

  if (completedConsumer) return null;

  return (
    <Joyride
      callback={handleSaveGuides}
      locale={locale}
      run={run}
      steps={steps}
      styles={consumerGuideStyle}
      continuous
      disableScrolling
    />
  );
};
